var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sakura-container"},_vm._l((_vm.petals),function(petal,i){return _c('div',{key:i,staticClass:"sakura",class:petal.type,style:(_vm.petalStyle(petal))})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }